import React from "react";
import Iterator from "../utils/Iterator";
import { LinkItem, LogOutButton } from "./LinkItem";
import LangSelect from "../langSelect/langSelect";
import { DarkModeToggle } from "../langSelect/DarkModeToggle";
import { indexStore } from "src/store/indexStore";
import { useParams } from "react-router-dom";
import Visibility from "../utils/Visibility";
import { Skeleton } from "../ui/skeleton";
import { User, Building2 } from "lucide-react";

export default function Sidebar(props) {
  const { branchId } = useParams();
  const { branch, nameLang, branchLoading } = indexStore();

  const userName = localStorage.getItem("userName");

  return (
    <aside className="hidden border-r bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 md:block sticky top-0 h-screen shadow-sm z-10">
      <div className="flex flex-col h-full overflow-hidden">
        {/* Header Section */}
        <div className="flex flex-col gap-3 p-4 lg:p-6 border-b bg-gradient-to-br from-primary/5 to-transparent">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary/10 border border-primary/20">
              <User className="w-5 h-5 text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-foreground truncate">
                {userName || "User"}
              </p>
              <p className="text-xs text-muted-foreground">
                {localStorage.getItem("role") === "admin" ? "Administrator" : "User"}
              </p>
            </div>
          </div>
          <Visibility visible={branchId}>
            <div className="flex items-center gap-2 px-2 py-1.5 rounded-lg bg-muted/50 border">
              <Building2 className="w-4 h-4 text-muted-foreground shrink-0" />
              <Visibility visible={branchLoading}>
                <Skeleton className="h-4 w-24" />
              </Visibility>
              <Visibility visible={!branchLoading}>
                <span className="text-xs font-medium text-foreground truncate">
                  {branch[nameLang]}
                </span>
              </Visibility>
            </div>
          </Visibility>
        </div>

        {/* Navigation Section */}
        <div className="flex-1 overflow-y-auto overflow-x-hidden">
          <nav className="w-full flex flex-col gap-1 p-2 text-sm font-medium lg:p-3">
            <Iterator
              data={props.siderLinks}
              render={(e) => <LinkItem item={e} />}
            />
          </nav>
        </div>

        {/* Footer Section */}
        <div className="border-t bg-muted/30 p-3 space-y-2">
          <div className="flex flex-col items-center gap-2">
            <LangSelect />
            <DarkModeToggle />
          </div>
          <div className="h-px bg-border" />
          <LogOutButton />
        </div>
      </div>
    </aside>
  );
}
